import { useEffect } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import {
  domainsErrorSelector,
  domainsStatusSelector
} from "Reducers/project/settings/domains/domains.selectors";
import { resetStatus } from "Reducers/project/settings/domains/domains.slice";
import {
  addDomainThunk,
  addDomainProps
} from "Reducers/project/settings/domains/thunks/addDomain.thunk";
import { getDomainsThunk } from "Reducers/project/settings/domains/thunks/getDomains.thunk";
import { getCommonError } from "Reducers/sliceFactory";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import type { Project } from "@packages/client";

export const useAddDomain = (project?: Project) => {
  const dispatch = useAppDispatch();
  const { projectId } = useDecodedParams<{
    projectId: string;
  }>();

  const { error } = getCommonError(
    useAppSelector(state => domainsErrorSelector(state, { projectId }))
  );

  const status = useAppSelector(state =>
    domainsStatusSelector(state, { projectId })
  );

  useEffect(() => {
    dispatch(resetStatus({ projectId }));
  }, [projectId, dispatch]);

  useEffect(() => {
    if (project?.id) {
      dispatch(getDomainsThunk({ project }));
    }
  }, [project?.id, project, dispatch]);

  const handleSave = (data: addDomainProps) => {
    if (!project) return;
    dispatch(addDomainThunk({ project, data }));
  };

  return {
    error: error.original ? error : null,
    status,
    handleSave
  };
};
